import { useBridgeApi } from '@/api/BridgeApi.ts';

import { ThinkingIndicator } from './ThinkingIndicator.tsx';

// A vibe edit runs on a worker and the result lands long after dispatch (often
// a minute or more). During that wait the agent turn has already ended, so the
// thread would otherwise look idle even though work is still happening. This
// reads the pending edit straight off the bridge's outstanding_requests so the
// spinner follows the conversation itself — independent of whether the
// right-side panel is open or showing the same artifact.
export const EditInProgressIndicator = ({ chatId }: { chatId: string }) => {
	const bridgeApi = useBridgeApi();
	const hasPendingEdit = Object.values(
		bridgeApi.user_state?.outstanding_requests ?? {},
	).some(
		(req) =>
			req?.type === 'request_edit_image' &&
			// A null chat_id is a single-user edit with no thread attribution, so
			// show it here rather than hiding it from every thread.
			(req.chat_id == null || req.chat_id === chatId),
	);

	if (!hasPendingEdit) return null;
	return <ThinkingIndicator fallback="Reworking the image…" />;
};
